import { useEffect } from "react";

function useAutoPlayVideo(videoRef, threshold = 0.5) {
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (video.paused) {
            video.play().catch(() => {
              // Ignore autoplay failures
            });
          }
        } else {
          if (!video.paused) {
            video.pause();
          }
        }
      },
      {
        threshold,
      }
    );

    observer.observe(video);

    return () => observer.disconnect();
  }, [videoRef, threshold]);
}

export default useAutoPlayVideo;